import React from 'react';
import { ImageProps } from '.';

const SvgFastshipBasicKor = ({ size = 82, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 5.125)) || 16} fill='none' viewBox='0 0 82 16' {...props}>
      <g fill='#3D4F6F' clipPath='url(#FastshipBasicKor_svg__a)'>
        <path d='M36.93 6.035h1.504v1.74H36.93v7.677h-2.06V.522h2.06v5.513ZM67.06 8.414H61.34v.935h4.104v3.642h-8.29v.82h8.682v1.543H55.11V11.58h8.273v-.737h-8.29V9.349h4.17v-.935h-5.706V6.888H67.06v1.526ZM79.798 12.729h-7.799v.967h8.224v1.658H69.954v-4.118h7.766V10.3h-7.799V8.676h9.876v4.053ZM42.849 13.517h8.484v1.673H40.755v-4.102h2.093v2.429ZM17.176 3.14c.388 0 .717.196.887.523L20.41 8.19c.099.196.12.43.05.635l-.928 2.744a.626.626 0 0 1-.618.43h-1.576c-.08 0-.15.047-.17.122-.599 1.605-2.096 2.735-3.392 2.735-1.297 0-2.005-1.055-1.606-2.586.04-.15-.06-.271-.22-.271H7.857c-.08 0-.15.048-.17.122-.598 1.606-2.096 2.735-3.393 2.735-1.296 0-2.004-1.055-1.606-2.586.04-.15-.059-.271-.219-.271H1.413c-.329 0-.53-.252-.43-.55l.669-2.008c.09-.27.329-.43.618-.43h8.65c.46 0 .838-.251.978-.672l1.606-4.77a.625.625 0 0 1 .619-.43h3.053Z' />
        <path
          fillRule='evenodd'
          d='M26.417 5.33h.949V1.867h1.7v10.139h-4.365V1.868h1.716V5.33Zm0 4.955h.949V6.987h-.95v3.298ZM31.355 5.33h.964V1.867h1.7v10.139H29.67V1.868h1.685V5.33Zm0 4.955h.964V6.987h-.964v3.298Z'
          clipRule='evenodd'
        />
        <path d='M52.658 10.268H39.039V8.595h13.619v1.673ZM79.798 3.426h2.01v1.69h-2.01v3.002h-2.094V.522h2.094v2.904Z' />
        <path
          fillRule='evenodd'
          d='M70.51 2.968h3.042V1.195h2.093V7.71h-7.21V1.195h2.076v1.773Zm0 3.1h3.042V4.542H70.51v1.526Z'
          clipRule='evenodd'
        />
        <path d='M51.006 4.986h-8.19V6.05h8.468v1.575H40.74V3.492h8.174V2.475h-8.207V.867h10.3v4.119ZM10.832 5.064c.329 0 .53.252.43.551l-.51 1.512c-.09.271-.33.429-.619.429H.455c-.329 0-.53-.251-.43-.55l.51-1.513c.09-.27.329-.43.619-.43h9.678ZM61.323 1.688h4.463V3.23h-4.202c.41.87 1.93 1.583 4.938 1.706l-.606 1.542c-2.762-.132-4.675-.837-5.623-1.97-.94 1.133-2.862 1.838-5.64 1.97l-.572-1.542C57.063 4.813 58.575 4.1 59 3.23h-4.169V1.688h4.43V.506h2.061v1.181ZM12.149 1.143c.328 0 .528.251.428.55l-.508 1.513c-.09.271-.33.429-.619.43H5.463c-.328-.001-.528-.252-.428-.551l.51-1.512c.09-.271.328-.43.618-.43h5.986Z' />
      </g>
      <defs>
        <clipPath id='FastshipBasicKor_svg__a'>
          <path fill='#fff' d='M0 0h82v16H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFastshipBasicKor;
